// @flow

export const FIBER_PROVIDERS = [
  'Hyperoptic Ltd',
  'COMMUNITY FIBE LIMITED / ZS COMMUNICATIONS LTD',
];

export const CABLING_TYPES = ['FTTH', 'Discreet Cabling', 'Access Points'];

export const OTHER_OPTION = 'Other';

export const isOtherSelected = (value: mixed): boolean =>
  value === OTHER_OPTION || (typeof value === 'object' && value !== null);

export const emptyDeploymentAreaItem = {
  enclosureID: '',
  enclosure: '',
  closeUpImageOfSplitterWallBox: null,
  wideViewImageOfSplitterWallbox: null,
  cablingIsInstalled: '',
  closeUpImageOfCableRoutes: null,
  wideViewImageOfCableRoutes: null,
  cablingEntering: '',
  newOrExistingContainment: '',
  poeCspInstalled: '',
  imageOfPoeCsp: null,
};
